import { render } from "./JifenPage.vue?vue&type=template&id=0ee94eaa&scoped=true&ts=true"
import script from "./JifenPage.vue?vue&type=script&lang=ts"
export * from "./JifenPage.vue?vue&type=script&lang=ts"

import "./JifenPage.vue?vue&type=style&index=0&id=0ee94eaa&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ee94eaa"]])

export default __exports__